import { styledComponent } from 'lib/styled_component';
import { Box } from 'aa-react-ui';

const Container = styledComponent(Box)`
    height: 100vh;
    width: inherit;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

Container.defaultProps = {
  bg: 'primary.70'
};

export default Container;
